
   const homeCarousel = [
        {
            title: "Toy Story 4",
            movie_tv: "movie",
            cardImg: "https://image.tmdb.org/t/p/original/w9kR8qbmQ01HwnvK4alvnQ2ca0L.jpg",
            doc_id: "SGqcPOq4m4j9rk9Nia8G",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/8760/1268760-i-1a2fd988c91e",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3128/1273128-t-7b5f3575aa95",
            info: {year: '2019', duration: '1h 44m', company: 'Disney', languages: '3 Languages', age: '7+'},
            description:{overview: 'Pixar Animation Studios proudly presents the adeventure of a lifetime!'},
            genre: ['Animation', 'Family', 'Comedy']
        },

        {
      
            title: "101 Dalmations",
            movie_tv: "movie",
            doc_id: "Jf7OeU2zaTXrvuEe6ycU",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3104/1233104-i-c30b5138d9d0",
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/5865/1275865-t-52e1200bd866',
            cardImg: "https://image.tmdb.org/t/p/original/mRY84MJeWKnp9joev82QtslJFvk.jpg",
            info: {year: '1961', duration: '1h 22m', company: 'Disney', languages: '7 Languages', age: "0+"},
            description: 'Cruella De Vil dognaps all of the Dalmatian puppies in London.',
            genre: ['Animation', 'Family', 'Action-Adventure']
        },

        {
         
            title: "WandaVision",
            movie_tv: "tv",
            doc_id: "9MvXQ8qG1QbGrN0vRhFJ",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3815/1233815-i-0f2c3b00169f",
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/4264/1274264-t-fcbac8185cfe',
            cardImg: "https://image.tmdb.org/t/p/original/glKDfE6btIRcVB5zrjspRIs4r52.jpg",
            info: {year: '2021', duration: '1 Season', company: null, languages: 'English', age: "13+"},
            description: 'Two super-powered beings living idealized suburban lives suspect that everything is not as it seems.',
            genre: ['Superhero', 'Drama', 'Fantasy', 'Romance']
        },

        {
      
            title: "Soul",
            movie_tv: "movie",
            doc_id: "8EADTLovBMo8and8rQma",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6620/1246620-i-7faca3942512",
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/9282/1279282-t-6c1c0a91d145',
            cardImg: "https://image.tmdb.org/t/p/original/hm58Jw4Lw8OIeECIq5qyPYhAeRJ.jpg",
            info: {year: '2020', duration: '1h 49m', company: 'Disney', languages: '11 Languages', age: "7+"},
            description: `Jamie Foxx stars in Pixar's "Soul", a comedy about what makes you...YOU.`,
            genre: ['Music', 'Fantasy', 'Animation', 'Family', 'Comedy']
        },

        {
            doc_id: "SGqcPOq4m4j9rk9Nia8G",
            title: "Modern Family",
            movie_tv: "movie",
            doc_id: "r8r2G8Arzri5NVLk7dar",
            cardImg: "https://image.tmdb.org/t/p/original/fu5vEUHgxkAPmX26ISQXqHmlPMq.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/9894/1259894-i-72dfb65d2e7c",
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/7895/1277895-t-5c76afe0a298',
            info: {year: '2020', duration: '11 seasons', company: null, languages: 'English', age: "16+"},
            description: `Modern Family views three families through a documentary-style lens`,
            genre: ['Comedy', 'Mochumentary', 'Sitcom', 'Family-Friendly']
        }
    ]

    const moviesCarousel = [
        {
            doc_id: "CRMOVd7zJPFr8jqWQsS1",
            title: "The princess",
            movie_tv: "movie",
            cardImg: "https://image.tmdb.org/t/p/original/gt9s8TtZZ36TXF1CE1y19rSpOZu.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/9804/1289804-i-258122f0c193",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/8271/1298271-t-8a0f6a097ce7",
            info: {year: '2022', duration: '1h 34m', company: 'Disney', languages: 'English', age: '18+'},
            description: 'The story of a formidable young royal in an action-packed fight to the death.',
            genre: ['Fantasy', 'Action-Adventure']
        },

         {
            doc_id: "aBtAIa9xvnuAw4V3wXL4",
            title: "Rise",
            movie_tv: "movie",
            cardImg: "https://image.tmdb.org/t/p/original/czXyMcmiulyZjhYAnnMwVhFCvN.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/2943/1282943-i-a7028d7a0553",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/9004/1299004-t-d351e155a40b",
            info: {year: '2022', duration: '1h 51m', company: 'Disney', languages: '5 languages', age: '13+'},
            description: 'Real-life story about the Antetokounmpos and the first trio of brothers to become NBA champions',
            genre: ['Drama', 'Sport', 'Biographical']
        },

         {
            doc_id: "lYdlP57zyLRfrwBJGM6S",
            title: "Doctor Strange in the mulltiverse",
            movie_tv: "movie",
            cardImg: "https://image.tmdb.org/t/p/original/9Gtg2DzBhmYamXBS1hKAhiwbBKS.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/9875/1279875-i-5551ece0127e",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3051/1283051-t-fed304636992",
            info: {year: '2022', duration: '2h 6m', company: 'Disney', languages: 'English', age: '18+'},
            description: 'Adventuring through the Multiverse, Doctor Stange breaks open infinite possibilities for the MCU',
            genre: ['Superhero', 'Fantasy', 'Action-Adventure']
        },

         {
            doc_id: "cFiNvzQraPhBz0cQNrjU",
            title: "X-MEN APOCALYPSE",
            movie_tv: "movie",
            cardImg: "https://image.tmdb.org/t/p/original/qttNmCib9gHhR5q0QoZ3FgmGom9.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/598/1240598-i-c5aa7650cc9a",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/1836/1301836-t-cc11a811ba04",
            info: {year: '2016', duration: '2h 25m', company: 'Disney', languages: '7 languages', age: '13+'},
            description: 'Apocalypse, the most powerful mutant in the universe, tries to destroy all of mankind.',
            genre: ['Superhero', 'Action-Adventure', 'Science Fiction']
        },

         {
            doc_id: "IMYYjNHelAfJQI5m0QsZ",
            title: "SPIDER-MAN HOMECOMING",
            movie_tv: "movie",
            cardImg: "https://image.tmdb.org/t/p/original/c24sv2weTHPsmDa7jEMN0m2P3RT.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto,w_828/sources/r1/cms/prod/7563/1277563-i-35e62c432023",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/9619/1279619-t-87c73024e872",
            info: {year: '2017', duration: '2h 13m', company: 'Disney', languages: '5 languages', age: '13+'},
            description: 'A young Peter Parker/Spider-Man navigates his newfound identity as the web-slinging superhero.',
            genre: ['Superhero', 'Coming of Age', 'Action-Adventure']
        },    
    ]

    const seriesCarousel = [
         {
            doc_id: "7k1zfvcFUoxpY3lJhpff",
            title: "BOB'S BURGERS",
            movie_tv: "tv",
            cardImg: "https://image.tmdb.org/t/p/original/qNsmGUUwdyHmkvxT1vCKMi8bBtF.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/352/1250352-i-9c4bec2412c5",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3888/1293888-t-512b9f1d63a7",
            info: {year: '2022', duration: '12 Seasons', company: null, languages: 'English', age: '16+'},
            description: 'A third-generation restaurateur named Bob runs Bob’s Burgers with the help of his wife and kids.',
            genre: ['Animation', 'Comedy']
        },

         {
            doc_id: "e27xvyp6L70xpyYVne5f",
            title: "CAPTIVE AUDIENCE",
            movie_tv: "tv",
            cardImg: "https://image.tmdb.org/t/p/original/cTeASlHFdnB4xBX9WrWuf4Sp9R0.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/2053/1292053-i-e7c22b96d94c",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3176/1303176-t-c625ba7a2fad",
            info: {year: '2022', duration: '1 Season', company: null, languages: 'English', age: '18+'},
            description: "In 1972, Steven vanishes. When he returns, the media can't get enough of the story.",
            genre: ['Docuseries']
        },

         {
            doc_id: "fiTJhwInUpQh3ioHuE9z",
            title: "STAR-WARS OBI - WAN KENOBI",
            movie_tv: "tv",
            cardImg: "https://image.tmdb.org/t/p/original/qJRB789ceLryrLvOKrZqLKr2CGf.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3287/1243287-i-ad92d6bb0ff5",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/2226/1292226-t-c3f039d29f21",
            info: {year: '2022', duration: '1 Season', company: null, languages: 'English', age: '13+'},
            description: "During the reign of the Empire, Obi-Wan Kenobi embarks on a crucial mission.",
            genre: ['Action-Adventure', 'Science Fiction',]
        },

         {
            doc_id: "uoqB76JlCNCQ26BZnezW",
            title: "MS MARVEL",
            movie_tv: "tv",
            cardImg: "https://image.tmdb.org/t/p/original/cdkyMYdu8ao26XOBvilNzLneUg1.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/9301/1269301-i-0950c2b5d912",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/2833/1302833-t-c6166b61ef08",
            info: {year: '2022', duration: '1 Season', company: null, languages: 'English', age: '13+'},
            description: 'Kamala Khan, a Muslim American teen, is a Super Hero mega fan who discovers she has super powers.',
            genre: ['Superhero', 'Coming of Age', 'Comedy']
        },

         {
            doc_id: "f3gdfdMLiFwStmsMf1hz",
            title: "The Kardashians",
            movie_tv: "tv",
            cardImg: "https://image.tmdb.org/t/p/original/3cJgB4fOfgHKNoHgtT3h1Qqkvxq.jpg",
            backgroundImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/345/1250345-i-adf25e769c4c",
            titleImg: "https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/3231/1293231-t-4412b7ec4295",
            info: {year: '2022', duration: '1 Season', company: null, languages: "English", age: '16+'},
            description: "The family you know and love is here with a brand new series.",
            genre: ['Reality']
        },
    ]

    export {homeCarousel, moviesCarousel, seriesCarousel}